import { connect } from "react-redux";
import DumbellChart from "./DumbellChart";


const mapStateToProps = (state) => ({


});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(DumbellChart);
